var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionLinesLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Agrupar_60",
    "data-name": "Agrupar 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.131,
    height: 1075.033,
    viewBox: "0 0 135.131 1075.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.901,
    y1: 1,
    x2: 0.92,
    y2: 5.451,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edd47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cab56d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_58",
    "data-name": "Agrupar 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M280.884,368.753V448.1h12.67V368.753a121.624,121.624,0,0,0-36.008-86.422l-52.672-52.56v17.908l43.712,43.608A109.048,109.048,0,0,1,280.884,368.753Z",
    transform: "translate(-204.874 -155.547)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M327.335,393.044v107.22H340V393.044A121.637,121.637,0,0,0,304,306.619l-99.123-98.911v17.918l90.163,89.951A109.048,109.048,0,0,1,327.335,393.044Z",
    transform: "translate(-204.874 -207.708)",
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Agrupar_57",
    "data-name": "Agrupar 57",
    transform: "translate(76.011 258.901)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_694",
    "data-name": "Ret\\xE2ngulo 694",
    width: 12.669,
    height: 816.131,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_695",
    "data-name": "Ret\\xE2ngulo 695",
    width: 12.668,
    height: 816.131,
    transform: "translate(46.451 0)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionLinesLeft);
export default __webpack_public_path__ + "static/media/solution_lines_left.37ddaac4194bfdd5a0d4baa59a0d229e.svg";
export { ForwardRef as ReactComponent };